<script>
  import options from './DeliveryInfo.options'
  export default options
</script>

<template>
  <p><button class="nlx-button" @click="copyForm">{{getLabel('copy_billing_information')}}</button></p>
  <form class="nlx-customer-info">

    <template v-for="(field,fieldIndex) in formConfig" :key="fieldIndex">
      
      <template v-if="(field.type === 'select')">
        <div class="nlx-customer-info__field nlx-customer-info__field--select" :class="{'nlx-customer-info__field--valid':field.valid, 'nlx-customer-info__field--invalid':field.required && !field.valid}">
          <label for="" class="nlx-customer-info__input-label">
            {{field.label}}
            <span v-if="field.required">*</span>
          </label>
          <select :disabled="disabled" class="nlx-select" v-model="field.value"  name="costumer-service-reason" id="costumer-service-reason-select">

            <template v-for="(option,optionIndex) in field.options" :key="optionIndex">
              <option :value="option.value">{{option.displayName}}</option>
            </template>
      
          </select>
        </div>
      </template>

      <template v-else>
        <div class="nlx-customer-info__field" :class="{'nlx-customer-info__field--valid':field.valid,  'nlx-customer-info__field--small':field.small, 'nlx-customer-info__field--invalid':field.required && !field.valid}">
          <input :disabled="disabled" class="nlx-customer-info__input-field" :id="field.name" :class="{'nlx-customer-info__input-field--dirty':field.value}" v-model="field.value">
          <label :for="field.name" class="nlx-customer-info__input-label">
            {{field.label}}
            <span v-if="field.required">*</span>
          </label>
        </div>
      </template>

    </template>
  </form>
</template>
